<template>
  <div class = "fixed-content">


      <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>STAGE Pictures</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p)}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>




    <div >
      <callingApiCenter :paths="['/api/w/gst/WebSearchCockpit' ,'/api/w/gst/updateyardstage','/api/w/gstConfirm/WebUpdateConfirmStages']">
      <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">create</span>BACK</md-button>
      <md-button class="md-raised custButton " v-if="!canSave" :disabled="!canChange" @click="doEdit" ><span class="icons-center material-icons">create</span>Edit</md-button>
      <md-button class="md-raised custButton " v-if="canSave" @click="doCancel" ><span class="icons-center material-icons">create</span>Cancel</md-button>
      <md-button class="md-raised custButton " :disabled="!canSave" @click="doSave" ><span class="icons-center material-icons">create</span>Save</md-button>
      <md-button class="md-raised custButton " :disabled="!canUnderCheck" @click="doUC"><span class="icons-center material-icons">create</span> Under Check</md-button>
      <md-button class="md-raised custButton "  :disabled="!canUnUnderCheck" @click="doCF"><span class="icons-center material-icons">create</span> Check finish</md-button>
      <md-button class="md-raised custButton "  :disabled="!canConfirm" @click="doSC"><span class="icons-center material-icons">create</span> Confirm</md-button>
      <md-button class="md-raised custButton " :disabled="!canUnConfirm" @click="doSU" ><span class="icons-center material-icons">create</span> Unconfirm</md-button>

      <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">create</span>LAST</md-button>
      <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" ><span class="icons-center material-icons">create</span>NEXT</md-button>


    </callingApiCenter>
    </div>
    
    <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Stage Information</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Delivery Type</label>
            <md-input v-model="params.deliveryType" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Sale Office</label>
            <md-input v-model="params.salesOffice" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Load Key</label>
            <md-input v-model="params.loadKey" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Route</label>
            <md-input v-model="params.route" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <label>Pick Up Location</label>
       <md-field>
            <!-- <label>Pick Up Location</label>
            <md-input v-model="params.pickUpLocationName" disabled></md-input> -->
             <master-data-display group="GST_LOCATION" :tag-id="params.pickupLocationCode"/>
        </md-field>
    </div>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Booking</label>
            <md-input v-model="params.bookObl" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>IN/OUT</label>
            <md-input v-model="params.stageType" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Stage Status</label>
            <md-input v-model="params.stageStatus" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Customer Reference</label>
            <md-input v-model="params.referenceNo" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <label>Delivery Location</label>
       <md-field>
            <!-- <label>Delivery Location</label>
            <md-input v-model="params.deliverLocationName" disabled></md-input> -->
            <master-data-display group="GST_LOCATION" :tag-id="params.deliverLocationCode"/>
        </md-field>
    </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Dispatch Instruction</label>
            <md-input v-model="params.dispatcherInstruction" disabled></md-input>
        </md-field>
    </div>
  </div>

  <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Driver Remark</label>
            <md-input v-model="params.comment" disabled></md-input>
        </md-field>
    </div>
  </div>

  <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Confirm Remark</label>
            <md-input v-model="params.stageConfirmComment" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
  </div>




  <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Delivery Start/End</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field >
            <label>Delivery Start</label>
            <md-input v-model="params.taskStartLocal" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Delivery Start Time</label>
            <md-input v-model="params.taskStartLocalTime" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <div v-if="params.pictureList" class = "photoFont">Picture For BOL : 
                {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_B')).length === 0 
                ? '' : '&#x2713;'  }}
            </div>
            <div v-else class = "photoFont">
                Picture For InterChange : 
            </div>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Off Site Scale</label>
            <md-input v-model="params.offsiteScale" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <div v-if="params.pictureList" class = "photoFont" >Picture for Scale Ticket : 
                {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_SD')).length === 0 
                ? '' : '&#x2713;'  }}
            </div>
            <div v-else class = "photoFont">
                Picture For InterChange : 
            </div>
        </md-field>
    </div>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Delivery End Date</label>
            <md-input v-model="params.taskEndLocal" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Delivery End Time</label>
            <md-input v-model="params.taskEndLocalTime" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <div v-if="params.pictureList" class = "photoFont">Picture for POD : 
                {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_TP')).length === 0 
                ? '' : '&#x2713;'  }}
            </div>
            <div v-else class = "photoFont">
                Picture For InterChange : 
            </div>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Drop Off CP</label>
            <md-input v-model="params.checkPoint" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
     <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <div class = "photoFont">Pictures: </div>
        <a href="" @click.prevent="toggleItemPhoto(params.pictureList)">{{params.pictures}} photos</a>
    </div>
    </div>



    <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Terminal Arrival/Leave</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Arrive Terminal Date</label>
            <md-input v-model="params.checkInLocal" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Arrive Terminal Time</label>
            <md-input v-model="params.checkInLocalTime" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
           <div v-if="params.pictureList" class = "photoFont">
                Picture For InterChange : {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_IC')).length === 0 
                ? '' : '&#x2713;'  }}
            </div>
            <div v-else class = "photoFont">
                Picture For InterChange : 
            </div>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Container</label>
            <md-input v-model="params.containerNo" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Carrier</label>
            <md-input v-model="params.carrier" disabled></md-input>
        </md-field>
    </div>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Leave Terminal Date</label>
            <md-input v-model="params.checkOutLocal" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Leave Terminal Time</label>
            <md-input v-model="params.checkOutLocalTime" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <div v-if="params.pictureList" class = "photoFont">Picture For InterChange : 
                {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_IC')).length === 0 
                ? '' : '&#x2713;'  }}
            </div>
            <div v-else class = "photoFont">
                Picture For InterChange : 
            </div>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Chassis #</label>
            <md-input v-model="params.chassisNo" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
     <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Chassis Vendor</label>
            <md-input disabled></md-input>
        </md-field>
    </div>
    </div>





    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Total Hours</label>
            <md-input v-model="params.totalHours" disabled></md-input>
        </md-field>
    </div>

    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Waiting Time Paid Out</label>
            <md-input v-model="params.waitingTimePaidOut" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>

   

    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
           <label v-if="params.pictureList">Pics for Addition Docs : 
                {{params.pictureList.filter(it => 
                it.photoKey.includes(params.loadKeyWithStageNo + '_A')).length === 0 
                ? '' : '&#x2713;'  }}
            </label>
            <label v-else >
                Picture For InterChange : 
            </label>
        </md-field>
    </div>

    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Additional Cost for Driver</label>
            <md-input v-model="params.addCostForDriver" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>


    </div>

    






    



  
    </div>

</template>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";





export default {

    data: () => ({
     loadList: [],
     params: [],
     pointer: null,
     items: ['1','2','3'],
     indicator: false,
     drivers: null,
     edit:false,
     photos: [],
     testphotos: [],
     photoZipFileName: '',
     filePrefixForEachFile: '',
     isPictureModalShowing: false,
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
  
    },


    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),

      canLast(){
        return this.pointer == 0;
      },


      canNext(){
        return this.pointer == this.loadList.length - 1;
      },


      getEditMode()
        {
            return this.edit;
        },


    canChange() {
        if (this.params.stageStatus != 'STC' )
          {
              return true
          }
      },

      canSave() {
        if (this.edit == true )
          {
              return true
          }
      },


    canUnderCheck() {
        if (this.params.stageStatus != 'STC' 
          && this.params.stageStatus != 'SUC' )
          {
              return true
          }
          
          
      },

      canUnUnderCheck() {

        if (this.params.stageStatus == 'SUC' )
          {
              return true
          }

      },

      canConfirm() {
        if (this.params.stageStatus != 'STC' 
          && this.params.stageStatus != 'SUC' )
          {
              return true
          }
      },


      canUnConfirm() {
        if (this.params.stageStatus == 'STC' )
          {
              return true
          }
      },

      


    },

    


    async mounted() {

        if (Array.isArray(this.$route.params))
        {
             this.loadList = this.$route.params
        }
        else
        {
            this.loadList = [this.$route.params]
           
        }

       // this.loadList = this.$route.params;

        
        
        this.params = this.loadList[0];
        console.log(this.params);
        this.pointer = 0;
          this.drivers = null;
      this.$store.dispatch('getUsersByCategory', { category: 'L' })
        .then((res) => {
          this.drivers = res;
        });
        this.doSearch();
    },
    methods: {



        async toggleItemPhoto(item) {
        this.isPictureModalShowing = true;
        this.photos = item;
        
        // this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;

      },

      getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },


        

        doAction(){

            this.$router.go(-1);
        },

        doBack(){
          
          this.pointer = this.pointer - 1;
          this.params = this.loadList[this.pointer];
          this.doSearch();

        },

        doNext(){

          this.pointer = this.pointer + 1;
          this.params = this.loadList[this.pointer];
          this.doSearch();

        },


        doNew(){

            this.items.push({
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            editing : true,
            });
        },


        doEdit(){
            
            this.params.change = true;
            this.edit = true
            console.log(this.params.change);
            console.log(this.getEditMode);
             console.log(this.params);
        },


        doCancel() {
           // this.params.change = false;
            this.edit = false;
        },


        doSave(item)
        {
            const request = this.params
            request.action = 'CHANGE';
            request.checkIn = dateFormat.getLocalTimeStamp(request.checkInLocal, request.checkInLocalTime);
            request.checkOut = dateFormat.getLocalTimeStamp(request.checkOutLocal, request.checkOutLocalTime);
            request.taskStart = dateFormat.getLocalTimeStamp(request.taskStartLocal, request.taskStartLocalTime);
            request.taskEnd = dateFormat.getLocalTimeStamp(request.taskEndLocal, request.taskEndLocalTime);
            console.log(request);
            //api.post("/api/w/gstConfirm/WebUpdateConfirmStages", request)
            newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", request)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
            this.edit = false;
          });
        },


        async doUC() {
          
            const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKeyWithStageNo: this.params.loadKeyWithStageNo,
                stageStatus: this.params.stageStatus,
            }]
            //api.post("/api/w/gstConfirm/WebUpdateConfirmStages", {
            newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", {
            action:"UC",
            status:requests,
            })
            .then(() => {
                this.$store.commit('clearApiError');
                this.doSearch();
            });
         
      },

      

      async doCF() {
       const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKeyWithStageNo: this.params.loadKeyWithStageNo,
                stageStatus: this.params.stageStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmStages", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", {
           action:"CF",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },

      

       async doSC() {
        const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKeyWithStageNo: this.params.loadKeyWithStageNo,
                stageStatus: this.params.stageStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmStages", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", {
           action:"SC",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },


      async doSU() {
       const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKeyWithStageNo: this.params.loadKeyWithStageNo,
                stageStatus: this.params.stageStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmStages", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmStages", {
           action:"SU",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },



    
      

      








        // doCancel(item){
        //     item.editing = false;
        // },

    //     canEdit(item){
    //       return item.editing != null
    //   },

        doSearch()
    {
        // if (this.params != null)
        // {
        //     const data = {
        //     loadKey: this.params.loadKey || this.params.seqNo,
        //     companyOffice: 'GST_' + this.params.salesOffice
        //         }
        //     console.log(data);
        //     api.post("/api/w/gst/WebSearchCockpit", data)
        //   .then((item) => {
        //     this.$store.commit('clearApiError');
        //     item.forEach((it) => {
        //     it.editing = false;
        //   });

        //     this.items = item;
        //     console.log(this.items);
        //   });

        // }
    },
    }

}
</script>

<style scoped>

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.75rem;
   
}

.photoFont {
    font-size: 1rem;
    color: gray;
    padding-bottom: 10px;
    
}




.holder {
    /* background: blue; */
    margin: 20px;
    width: 800px;
    height: 200px;
}

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}

.md-title {
    margin-left: 20px;
}



</style>